export default function SkeletonCourseSection() {
  return (
    <section className="course_section section_padding">
      <div className="container">
        <div className="course-section-card">
          {/* Section Title */}
          <div className="section_title mb-6">
            <div className="flex items-center space-x-3 mb-2">
              <div className="w-8 h-8 bg-gray-300 rounded animate-pulse"></div>
              <div className="h-8 bg-gray-300 rounded w-48 animate-pulse"></div>
            </div>
            <div className="h-4 bg-gray-300 rounded w-64 animate-pulse"></div>
          </div>

          {/* Program Filters */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
            {[1, 2, 3, 4].map((item) => (
              <div key={item} className="program-item cursor-wait" aria-busy="true">
                <div className="item-card flex items-center space-x-3 p-3 flex-shrink-0 border border-gray-300 rounded-md overflow-hidden shadow-sm bg-white">
                  <div className="w-12 h-12 bg-gray-300 rounded-full animate-pulse"></div>
                  <div className="h-5 bg-gray-300 rounded w-24 animate-pulse"></div>
                </div>
              </div>
            ))}
          </div>

          {/* Course Slider Placeholder */}
          <div className="course-slider">
            <div className="courses flex space-x-4 overflow-x-auto">
              {[1, 2, 3, 4].map((item) => (
                <div
                  key={item}
                  className="course-item animate-pulse w-75 flex-shrink-0 border rounded-md overflow-hidden shadow-sm bg-white"
                  aria-busy="true"
                  aria-label="Loading course card"
                >
                  {/* Image Skeleton */}
                  <div className="course-image bg-gray-300 w-full h-40 rounded-md" />

                  {/* Content Skeleton */}
                  <div className="item-content p-4 space-y-3">
                    <div className="h-5 w-24 bg-gray-300 rounded"></div> {/* Timer */}
                    <div className="h-6 bg-gray-300 rounded"></div> {/* Title */}
                    <div className="h-8 w-32 bg-gray-300 rounded"></div> {/* Button */}
                  </div>
                </div>
              ))}
            </div>

            {/* Arrows */}
            <div className="course_arrow mt-6 flex justify-between px-4">
              <button
                className="arrow-icon w-10 h-10 bg-gray-300 rounded-full animate-pulse"
                aria-hidden="true"
              ></button>
              <button
                className="arrow-icon w-10 h-10 bg-gray-300 rounded-full animate-pulse"
                aria-hidden="true"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
